import { HttpEvent, HttpEventCallbacks, httpGet, httpPost } from "@/events/eventsDomain";
import { toQueryString } from "@/utils/queryParams";
import type {
  CompanyFieldCommand,
  CompanyFieldDetails,
  CompanyFieldRef,
} from "./companyFieldDomain";

const fieldPath = (field: CompanyFieldRef): string => {
  switch (field.source) {
    case "SYSTEM":
      return `system/${field.field}`;
    case "CUSTOM":
      return `custom/${encodeURIComponent(field.definitionId)}`;
  }
};

export const companyFieldApiClient = {
  details: (
    orgNo: string,
    field: CompanyFieldRef,
    asOf: string | undefined,
    params: HttpEventCallbacks<CompanyFieldDetails>,
  ): HttpEvent<CompanyFieldDetails> =>
    httpGet({
      url: `/company-fields/${encodeURIComponent(orgNo)}/${fieldPath(field)}${toQueryString({ asOf })}`,
      ...params,
    }),

  command: (
    orgNo: string,
    data: CompanyFieldCommand,
    params: HttpEventCallbacks<CompanyFieldDetails>,
  ): HttpEvent<CompanyFieldDetails> =>
    httpPost({ url: `/company-fields/${encodeURIComponent(orgNo)}/commands`, data, ...params }),
};
